<template>
    <div class="tw:w-full tw:md:w-sm">
        <form @submit.prevent="$emit('search')" class="tw:flex tw:gap-2">
            <input type="text"
                class="tw:w-full tw:px-3 tw:py-2 tw:text-sm tw:border tw:border-slate-200 tw:rounded-xl tw:bg-white tw:text-slate-800 tw:focus:outline-none tw:focus:border-slate-400"
                :value="value" @input="$emit('input', $event.target.value)" :placeholder="placeholder">
            <button
                class="tw:inline-flex tw:items-center tw:gap-1.5 tw:px-4 tw:py-2 tw:rounded-xl tw:bg-slate-900 tw:text-white tw:text-sm tw:font-semibold tw:transition-all tw:hotw:hover:bg-slate-800 tw:shrink-0"
                type="submit">
                <i class="fa fa-search"></i> Buscar
            </button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'SearchBox',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Buscar...'
        }
    }
}
</script>